<template>
    <div class="qksm qksm2">
        <p><b>（二）财政拨款收支情况</b></p>
        <div class="nogap">
            <p>
                2021年财政拨款收入预算为{{isMoney(T4.收入总计)}}万元{{num(T4.收入总计)==0 ? '。' : '，其中：'}}
                <span v-for="(item, idx) in T4.收入">
                    {{item.name}}{{isMoney(item.value)}}万元，占{{getPercentValue(T4.收入.map(e=>e.value), idx, 2)}}{{idx==T4.收入.length-1?'。':'；'}}
                </span>
            </p>
        </div>
        <div id="myChart3" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        <div class="nogap">
            <p>
                2021年财政拨款支出预算为{{isMoney(T4.支出总计)}}万元{{num(T4.支出总计)==0 ? '。' : '，其中：'}}
                <span v-for="(item, idx) in T4.支出">
                    {{item.name}}（类）支出{{isMoney(item.value)}}万元，占{{getPercentValue(T4.支出.map(e=>e.value), idx, 2)}}{{idx==T4.支出.length-1?'。':'；'}}
                </span>
            </p>
        </div>
        <div id="myChart4" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
    </div>
</template>
<script>
    export default {
        name: "qksm3",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T4: {
                type: Object,
                default: "",
            },
        },
    };
</script>